import { EExcelConnectCurrentActions, ExcelConnectCurrentActions } from '../actions/excel-connector-current.actions';

export const initialExcelConnectorCurrentReducer: IExcelConnectorCurrentReducer = {
    isLoading: false,
    isUploading: false,
    connector: {
        name: '',
        description: '',
        children: [],
        versionDetail: {
            id: '',
            name: '',
            description: '',
            actions: [],
            excelFile: { name: '', id: '', content: '' },
            version: ''
        }
    },
    uploadedFileName: ''
}

export function excelConnectorCurrentReducer(state = initialExcelConnectorCurrentReducer,
  action: ExcelConnectCurrentActions): IExcelConnectorCurrentReducer {

    switch (action.type) {

        case EExcelConnectCurrentActions.SetCurrentConnector: {
            const connector = {
                ...action.payload,
                children: action.payload.children.map((child: IExcelConnectorChildren) => {
                    return { ...child }
                })
            };

            const newState = {
                ...state,
                connector
            }
            return newState;
        }

        case EExcelConnectCurrentActions.UploadExcelFile: {
            const newState = {
                ...state,
                isUploading: true
            }
            return newState;
        }

        case EExcelConnectCurrentActions.UploadExcelFileSuccess: {
            const newState = {
                ...state,
                isUploading: false
            }
            return newState;
        }

        case EExcelConnectCurrentActions.UploadExcelFileError: {
            const newState = {
                ...state,
                isUploading: false
            }
            return newState;
        }

        case EExcelConnectCurrentActions.GetDetailFromVersion: {
            const newState = {
                ...state,
                isLoading: true
            }
            return newState;
        }

        case EExcelConnectCurrentActions.GetDetailFromVersionSuccess: {
            const newState = {
                ...state,
                isLoading: false,
                connector: {
                    ...state.connector,
                    versionDetail: {
                        ...action.payload
                    }
                },
                uploadedFileName: action.payload.excelFile.name
            }
            return newState;
        }

        case EExcelConnectCurrentActions.SetSelectedFileName: {
            const newState = {
                ...state,
                uploadedFileName: action.payload
            }
            return newState;
        }

        case EExcelConnectCurrentActions.ResetDetailFromVersion: {
            return initialExcelConnectorCurrentReducer;
        }

        default: {
            return state;
        }
    }
}
